import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { PregledSpecifikacijaComponent } from './pregled-specifikacija.component';

import { TabsModule } from 'beyond-util';

@NgModule({
  declarations: [PregledSpecifikacijaComponent],
  entryComponents: [PregledSpecifikacijaComponent],
  exports: [PregledSpecifikacijaComponent],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TabsModule,
  ],
})
export class PregledSpecifikacijaModule {}



// WEBPACK FOOTER //
// ./src/app/pages/pregled-specifikacija/pregled-specifikacija.module.ts